var _style, _path, _path2, _circle, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".trash_svg__st4,.trash_svg__st5{fill:none;stroke:#35a4dd;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.trash_svg__st5{stroke:#f9af17}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.4 218.9L253.8 983h516.4l38.5-418.3M91.3 201.1h841.4M339 41.7h337v159.4H339z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 802.2V353.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 817.4,
    cy: 468.9,
    r: 32.6,
    fill: "#35a4dd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M642 802.2V353.8M380.6 802.2V353.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M826.4 373.2l14.2-155"
  })));
}

export default SvgTrash;